module.exports = __webpack_public_path__ + "static/media/bg_dino.6751dd1e.mp3";